// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

const fragments = {
  TRIGGER: '[data-fragment="FooterHandler.trigger"]',
  MENU: '[data-fragment="FooterHandler.menu"]',
};
const COOKIE_NAME = 'footerSeen';

export default class FooterHandler extends WebComponent {

  constructor(props) {
    super(props);
    this.handleMenu = this.handleMenu.bind(this);
    this.checkForCookie = this.checkForCookie.bind(this);
  }

  didMount() {
    this.trigger = this.element.querySelector(fragments.TRIGGER); // triggr
    this.menu = this.element.querySelector(fragments.MENU); // menu
    this.footerScrollTarget =  this.element.querySelector('.footer__menu-contact'); // scroll target

    this.trigger.addEventListener('click', this.handleMenu);

    // Creating cookie
    if (!cookie.get(COOKIE_NAME)) cookie.set(COOKIE_NAME, '');

    // Check for information if they have been seen
    this.checkForCookie();
  }

  checkForCookie() {
    const seenElements = cookie.get(COOKIE_NAME).split('|');

    for (let i = 0; i < seenElements.length; i++) {
      if (!isNaN(seenElements[i])) seenElements[i] = parseInt(seenElements[i], 10);
    }

    if (seenElements.includes(this.props.is)) {
      this.trigger.classList.remove('active');
      this.menu.classList.remove('active');
    }
  }

  handleMenu(e) {
    const seenElements = cookie.get(COOKIE_NAME).split('|');

    if (!seenElements.includes(this.props.is)) {
      cookie.set(COOKIE_NAME, (cookie.get(COOKIE_NAME) + this.props.is + '|'), { expires: 365.2425 * 5 });
    }
    this.trigger.classList.toggle('active');
    this.menu.classList.toggle('active');

    if (this.menu.classList.contains('active')) {
      this.timeout = setTimeout(() => {
        this.footerScrollTarget.scrollIntoView({behavior: "smooth", block: "end"});
      }, 200);
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FooterHandler.js